export enum DeltaComparisonMethod {
    LastResult = 1,
    AverageLastNResults = 2
}